import { TableauFallback, SansSerifFallback } from '../FormattingConverterConstants';
import { startsWithString } from './TypeUtil';

export class TextFontUtil {
  /**
   * Takes a list of current font families and adds 'Arial, sans-serif' if Roboto or any Tableau font is used.
   *
   * It is possible to have Arial listed twice if it is already in the list, but this algorithm will not
   * add it multiple times. This is done to save checking the entire list to determine if Arial is somewhere
   * in the list, since Arial is normally our fallback and should always be at the end, and functionally having
   * it twice in the browser is not an issue.
   * @param fontFamilies List of current fallbacks.
   */
  static addFallbackFonts(fontFamilies: string[]): void {
    if (this.hasAtLeastOneFontNeedingFallbacks(fontFamilies)) {
      // Add both the fallback and sans-serif as the final backup.
      fontFamilies.push(TableauFallback);
      fontFamilies.push(SansSerifFallback);
    }
  }

  static hasAtLeastOneFontNeedingFallbacks(fontFamilies: string[]): boolean {
    const fontsThatNeedFallbacks: string[] = ['tableau', 'roboto'];

    for (let currentFont of fontFamilies) {
      // At this point it will be assumed that each name is well-formed, and will either have no quotes,
      // single quotes around the name, double quotes around the name, or both, but will not have mismatches.
      // This will allow using simple substrings to remove any leading quotes to get to the first name of the
      // font, which will be more performant than a replace and should be more performant than a regex.
      currentFont = currentFont.trim();
      for (let j = 0; j < 2; j++) {
        if (startsWithString(currentFont, "'") || startsWithString(currentFont, '"')) {
          currentFont = currentFont.substr(1);
        }
      }

      if (fontsThatNeedFallbacks.some((f) => startsWithString(currentFont.toLowerCase(), f))) {
        return true;
      }
    }
    return false;
  }
}
